import React from 'react';
import { connect } from 'react-redux';
import t from 'common/i18n';
import ResultImageGrid from 'root/components/ResultImageGrid';
import { selectContextItems, selectSearchSummary } from '../../selectors';

import './ContextItems.scss';

export const ContextItems = (props) => {
  const topBarRenderer = () =>
    props.searchSummary ? <span className="b">{t('shutterstock.filter_summary.label', { summary: props.searchSummary })}</span> : null;

  return (
    <div className={`context-items w-100 h-100 photos-${props.context.context}`}>
      <ResultImageGrid
        images={props.searchSummary ? props.items : props.items.slice(0, props.isFiltersPanelOpen ? 3 : 4)}
        selected={props.selected}
        selectionAction={props.onSelect}
        showProgressIndicator={props.inProgress}
        onLoadMore={props.onLoadMore}
        isMultiple={false}
        useImageClientSize
        itemWidth={props.isFiltersPanelOpen ? 170 : null}
        topBarRenderer={props.onLoadMore && topBarRenderer}
        hasMore={props.hasMore}
      />
    </div>
  );
};
export default connect(
  (state) => ({
    ...selectContextItems(state),
    searchSummary: selectSearchSummary(state),
  }),
  null
)(ContextItems);
